<template>
  <v-container
    class="container-bg rounded elevation-3"
    fluid>
    <v-row>
      <v-col cols="12">
        <v-tabs v-model="selectTab">
          <v-tab> เลือกสินค้า </v-tab>
          <v-tab> Import CSV </v-tab>
        </v-tabs>
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col
            cols="12"
            md="4">
            <v-btn
              color="secondary"
              outlined
              small
              :loading="loading"
              :disabled="itemSelected.length === 0"
              @click="() => itemSelected = []">
              reset ({{ itemSelected.length }} รายการ)
            </v-btn>
          </v-col>
          <v-col
            cols="12"
            md="8"
            class="d-flex justify-end align-end"
            style="gap: 0.5rem;">
            <v-btn
              color="secondary"
              outlined
              small
              :loading="loading"
              :disabled="itemSelected.length === 0"
              @click="onConfirmHideFromWeb()">
              ซ่อนจากเว็บ
            </v-btn>
            <v-btn
              color="error"
              outlined
              small
              :loading="loading"
              :disabled="itemSelected.length === 0"
              @click="onConfirmShowOnWeb()">
              แสดงบนเว็บ
            </v-btn>
            <v-btn
              color="success"
              outlined
              small
              :loading="loading"
              :disabled="itemSelected.length === 0"
              @click="addTags()">
              เพิ่ม Tags
            </v-btn>
            <v-btn
              color="error"
              outlined
              small
              :loading="loading"
              :disabled="itemSelected.length === 0"
              @click="removeTags()">
              ลบ Tags
            </v-btn>
            <v-btn
              color="success"
              outlined
              small
              :loading="loading"
              :disabled="itemSelected.length === 0"
              @click="addGroupCategories()">
              เพิ่ม Group Categories
            </v-btn>
            <v-btn
              color="error"
              outlined
              small
              :loading="loading"
              :disabled="itemSelected.length === 0"
              @click="removeGroupCategories()">
              ลบ Group Categories
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col>
        <v-tabs-items v-model="selectTab">
          <v-tab-item>
            <v-col cols="12">
              <v-row justify="space-between">
                <v-col
                  cols="12"
                  md="12"
                  class="d-flex justify-end align-end">
                  <search-by-tags-and-brand
                    v-model="query"
                    append-icon="mdi-magnify"
                    tags-width="300px"
                    show-collection
                    :is-mobile="isMobile"
                    @on-search="fetchProducts(true)" />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-data-table
                v-model="itemSelected"
                :headers="headers"
                :items="products"
                :items-per-page="query.limit"
                :loading="loading"
                show-select
                item-key="model"
                fixed-header
                hide-default-footer
                height="calc(100vh - 380px)">
                <template #[`item.image`]="{ item }">
                  <div class="py-2">
                    <v-img
                      :src="imageUrl(item.photoUrls[0])"
                      :lazy-src="lazyImageUrl(item.photoUrls[0])"
                      width="60"
                      height="80"
                      cover />
                  </div>
                </template>
                <template #[`item.tags`]="{ item }">
                  <div
                    class="d-flex flex-row align-center flex-wrap py-2"
                    style="gap: 0.25rem;">
                    <v-chip
                      v-for="(tag, tIndex) in item.tags"
                      :key="`${tag}-tag-${tIndex}`"
                      color="secondary"
                      text-color="white"
                      small
                      label>
                      {{ tag }}
                    </v-chip>
                  </div>
                </template>
                <template #[`item.groupCategories`]="{ item }">
                  <div
                    class="d-flex flex-row align-center flex-wrap py-2"
                    style="gap: 0.25rem;">
                    <v-chip
                      v-for="(groupCategory, tIndex) in item.groupCategories"
                      :key="`${groupCategory}-tag-${tIndex}`"
                      color="secondary"
                      text-color="white"
                      small
                      label>
                      {{ groupCategory }}
                    </v-chip>
                  </div>
                </template>
                <template #[`item.categories`]="{ item }">
                  <div
                    class="d-flex flex-row align-center flex-wrap py-2"
                    style="gap: 0.25rem;">
                    <v-chip
                      v-for="(category, tIndex) in item.categories"
                      :key="`${category}-category-${tIndex}`"
                      color="secondary"
                      text-color="white"
                      small
                      label>
                      {{ category }}
                    </v-chip>
                  </div>
                </template>
                <template #[`item.international`]="{ item }">
                  <v-icon
                    v-if="isIncludeTags(item, ['sgweb', 'interweb'])"
                    color="success">
                    mdi-check
                  </v-icon>
                  <v-icon
                    v-else
                    color="error">
                    mdi-close
                  </v-icon>
                </template>
                <template #[`item.isOnWeb`]="{ item }">
                  <v-icon
                    v-if="item.isOnWeb"
                    color="success">
                    mdi-check
                  </v-icon>
                  <v-icon
                    v-else
                    color="error">
                    mdi-close
                  </v-icon>
                </template>
                <template #[`item.memberPromotion`]="{ item }">
                  <v-icon
                    v-if="isIncludeTags(item, ['900'])"
                    color="success">
                    mdi-check
                  </v-icon>
                  <v-icon
                    v-else
                    color="error">
                    mdi-close
                  </v-icon>
                </template>
                <template #[`item.soon`]="{ item }">
                  <v-icon
                    v-if="isIncludeTags(item, ['soon'])"
                    color="success">
                    mdi-check
                  </v-icon>
                  <v-icon
                    v-else
                    color="error">
                    mdi-close
                  </v-icon>
                </template>
                <template #[`item.ffm`]="{ item }">
                  <v-icon
                    v-if="loadingFFM"
                    color="secondary"
                    class="spin">
                    mdi-loading
                  </v-icon>
                  <v-icon
                    v-else-if="isIncludeTags(item, fulFillmentTags)"
                    color="success">
                    mdi-check
                  </v-icon>
                  <v-icon
                    v-else
                    color="error">
                    mdi-close
                  </v-icon>
                </template>
                <template #[`item.noAction`]="{ item }">
                  <v-icon
                    v-if="isIncludeTags(item, ['noaction'])"
                    color="success">
                    mdi-check
                  </v-icon>
                  <v-icon
                    v-else
                    color="error">
                    mdi-close
                  </v-icon>
                </template>
              </v-data-table>
            </v-col>
            <v-col cols="12">
              <v-pagination
                v-model="query.page"
                :length="totalPage"
                :disabled="loading"
                total-visible="7"
                color="secondary" />
            </v-col>
          </v-tab-item>
          <v-tab-item>
            <v-col cols="12">
              <div v-if="productImport.length > 0">
                <span
                  class="mr-2">
                  ข้อมูลทั้งหมด {{ productImport.length }} รายการ
                </span>
                <span
                  v-if="productImport.filter(p => p.error).length > 0"
                  class="mr-2">
                  -
                  <span class="text-error">
                    พบข้อผิดพลาด {{ productImport.filter(p => p.error).length }} รายการ
                  </span>
                </span>
              </div>
              <v-data-table
                v-if="productImport.length !== 0"
                v-model="itemSelected"
                :headers="headers"
                :items="productImport"
                :items-per-page="-1"
                :loading="loading"
                :item-disabled="productImport.filter((p) => p.error)"
                show-select
                item-key="model"
                fixed-header
                hide-default-footer
                height="calc(100vh - 260px)"
                @toggle-select-all="toggleSelectAll">
                <template #[`item.data-table-select`]="{ item, isSelected, select }">
                  <v-checkbox
                    class="mx-1"
                    :disabled="item.error"
                    :value="isSelected"
                    @click="select(!isSelected)" />
                </template>
                <template #[`item.image`]="{ item }">
                  <div class="py-2">
                    <v-img
                      :src="imageUrl(item.photoUrls[0])"
                      :lazy-src="lazyImageUrl(item.photoUrls[0])"
                      width="60"
                      height="80"
                      cover />
                  </div>
                </template>
                <template #[`item.tags`]="{ item }">
                  <div
                    class="d-flex flex-row align-center flex-wrap py-2"
                    style="gap: 0.25rem;">
                    <v-chip
                      v-for="(tag, tIndex) in item.tags"
                      :key="`${tag}-tag-${tIndex}`"
                      color="secondary"
                      text-color="white"
                      small
                      label>
                      {{ tag }}
                    </v-chip>
                  </div>
                </template>
                <template #[`item.name`]="{ item }">
                  <div :class="{ 'text-error': item.error } ">
                    {{ item.name }}
                  </div>
                  <div
                    v-if="item.error"
                    class="text-error">
                    {{ item.errorMessage }}
                  </div>
                </template>
                <template #[`item.groupCategories`]="{ item }">
                  <div
                    class="d-flex flex-row align-center flex-wrap py-2"
                    style="gap: 0.25rem;">
                    <v-chip
                      v-for="(groupCategory, tIndex) in item.groupCategories"
                      :key="`${groupCategory}-tag-${tIndex}`"
                      color="secondary"
                      text-color="white"
                      small
                      label>
                      {{ groupCategory }}
                    </v-chip>
                  </div>
                </template>
                <template #[`item.categories`]="{ item }">
                  <div
                    class="d-flex flex-row align-center flex-wrap py-2"
                    style="gap: 0.25rem;">
                    <v-chip
                      v-for="(category, tIndex) in item.categories"
                      :key="`${category}-category-${tIndex}`"
                      color="secondary"
                      text-color="white"
                      small
                      label>
                      {{ category }}
                    </v-chip>
                  </div>
                </template>
                <template #[`item.international`]="{ item }">
                  <v-icon
                    v-if="isIncludeTags(item, ['sgweb', 'interweb'])"
                    color="success">
                    mdi-check
                  </v-icon>
                  <v-icon
                    v-else
                    color="error">
                    mdi-close
                  </v-icon>
                </template>
                <template #[`item.isOnWeb`]="{ item }">
                  <v-icon
                    v-if="item.isOnWeb"
                    color="success">
                    mdi-check
                  </v-icon>
                  <v-icon
                    v-else
                    color="error">
                    mdi-close
                  </v-icon>
                </template>
                <template #[`item.memberPromotion`]="{ item }">
                  <v-icon
                    v-if="isIncludeTags(item, ['900'])"
                    color="success">
                    mdi-check
                  </v-icon>
                  <v-icon
                    v-else
                    color="error">
                    mdi-close
                  </v-icon>
                </template>
                <template #[`item.soon`]="{ item }">
                  <v-icon
                    v-if="isIncludeTags(item, ['soon'])"
                    color="success">
                    mdi-check
                  </v-icon>
                  <v-icon
                    v-else
                    color="error">
                    mdi-close
                  </v-icon>
                </template>
                <template #[`item.ffm`]="{ item }">
                  <v-icon
                    v-if="loadingFFM"
                    color="secondary"
                    class="spin">
                    mdi-loading
                  </v-icon>
                  <v-icon
                    v-else-if="isIncludeTags(item, fulFillmentTags)"
                    color="success">
                    mdi-check
                  </v-icon>
                  <v-icon
                    v-else
                    color="error">
                    mdi-close
                  </v-icon>
                </template>
                <template #[`item.noAction`]="{ item }">
                  <v-icon
                    v-if="isIncludeTags(item, ['noaction'])"
                    color="success">
                    mdi-check
                  </v-icon>
                  <v-icon
                    v-else
                    color="error">
                    mdi-close
                  </v-icon>
                </template>
              </v-data-table>
              <div
                v-else
                class="drop-area"
                :class="{ 'drag-over': isDragging }"
                @click="openFileDialog"
                @dragover.prevent="onDragOver"
                @dragleave.prevent="onDragLeave"
                @drop.prevent="onDrop"
              >
                <div v-if="loading">
                  <img
                    class="cat-loading"
                    src="@/assets/image/cat-what.gif"
                    alt="cat-loading">
                </div>
                <div v-else>
                  <p>
                    Drag & Drop "<b>CSV</b>" with template below here or click to select.
                  </p>
                  <div class="template-wrapper">
                    <img
                      src="@/assets/image/template-upload-product-attribute-assign.png"
                      width="200px"
                      style="margin: auto;"
                      alt="template upload product attribute assign">
                  </div>
                </div>

                <input
                  ref="fileInput"
                  type="file"
                  accept="text/csv"
                  multiple
                  hidden
                  @change="onFileChange" />
              </div>
            </v-col>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
    <TagsSelectorModal
      v-model="dialog"
      :products="itemSelected"
      :add="isAdd"
      @updated="selectTab === 0 ? fetchProducts(true) : fetchProductImport()" />
    <GroupCategoriesSelectorModal
      v-model="groupCategoriesDialog"
      :products="itemSelected"
      :add="isAdd"
      @updated="selectTab === 0 ? fetchProducts(true) : fetchProductImport()" />
  </v-container>
</template>

<script>
import AttributesAssignerProvider from '@/resources/AttributesAssignerProvider'
import ProductProvider from '@/resources/ProductProvider'
import OrderfulfillmentSettingNewProvider from '@/resources/OrderfulfillmentSettingNewProvider'
import SearchByTagsAndBrand from '@/components/SearchByTagsAndBrand.vue'
import ConvertQueryStringToArray from '@/assets/js/ConvertQueryStringToArray'
import NoPicture from '@/assets/image/no_picture_available.png'
import TagsSelectorModal from '../components/TagsSelectorModal.vue'
import GroupCategoriesSelectorModal from '../components/GroupCategoriesSelectorModal.vue'

const AttributesAssignerService = new AttributesAssignerProvider()
const ProductService = new ProductProvider()
const OrderfulfillmentSettingService = new OrderfulfillmentSettingNewProvider()

export default {
  components: {
    SearchByTagsAndBrand,
    TagsSelectorModal,
    GroupCategoriesSelectorModal
  },
  data () {
    return {
      noPicture: NoPicture,
      selectTab: 0,
      isDragging: false,
      headers: [
        {
          text: 'Image',
          value: 'image',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Name',
          value: 'name',
          sortable: false
        },
        {
          text: 'Tags',
          value: 'tags',
          sortable: false
        },
        {
          text: 'Group Categories',
          value: 'groupCategories',
          sortable: false
        },
        {
          text: 'Active on Web',
          value: 'isOnWeb',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Soon',
          value: 'soon',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Custom FFM',
          value: 'ffm',
          sortable: false,
          align: 'center'
        },
        {
          text: 'International',
          value: 'international',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Member Promotion',
          value: 'memberPromotion',
          sortable: false,
          align: 'center'
        },
        {
          text: 'No Action',
          value: 'noAction',
          sortable: false,
          align: 'center'
        }
      ],
      itemSelected: [],
      products: [],
      rawProductImport: [],
      productImport: [],
      fulFillmentTags: [],
      query: {
        page: 1,
        limit: 100,
        sortBy: 'createdAt',
        sortOrder: 'desc',
        search: '',
        tags: [],
        tagOperation: 'OR',
        brand: 'all',
        collection: ''
      },
      totalPage: 1,
      totalProduct: 0,
      loading: false,
      loadingFFM: false,
      dialog: false,
      groupCategoriesDialog: false,
      isAdd: false
    }
  },
  computed: {
    isMobile () {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm
    }
  },
  watch: {
    'query.page': {
      handler () {
        this.fetchProducts()
      },
      deep: true
    },
    selectTab () {
      if (this.selectTab === 0) {
        this.fetchProducts(true)
      } else {
        this.rawProductImport = []
        this.productImport = []
      }
      this.itemSelected = []
    }
  },
  mounted () {
    this.queryTags()
    this.fetchProducts()
    this.getFulfillmentTags()
  },
  methods: {
    toggleSelectAll ({ items }) {
      const filterProduct = items.filter((p) => !p.error)
      this.itemSelected = this.itemSelected.length === filterProduct.length ? [] : filterProduct
    },
    lazyImageUrl (src) {
      return src ? this.$convertImgix(`${src}?w=2&h=2&fit=clamp`) : this.noPicture
    },
    imageUrl (src) {
      return src ? this.$convertImgix(`${src}?w=128`) : this.noPicture
    },
    async fetchProducts (isClear = false) {
      if (this.loading) {
        return
      }

      try {
        this.loading = true

        if (isClear) {
          this.query.page = 1
          this.products = []
        }

        this.$router.push({
          name: 'AttributesAssigner',
          query: {
            search: this.query.search,
            tags: this.query.tags || [],
            tagOperation: this.query.tagOperation,
            brand: this.query.brand,
            collection: this.query.collection
          }
        }, () => {})

        this.queryTags()

        const { data } = await ProductService.getProducts(this.query)

        this.totalPage = data.pages
        this.totalProduct = data.total
        this.products = data.results.map((re) => ({
          id: re.id,
          model: re.model,
          name: re.name,
          isOnWeb: re.isOnWeb,
          photoUrls: re.photoUrls,
          tags: re.tags,
          groupCategories: re.groupCategories
        }))
      } catch (error) {
        console.error('fetchProducts', error)
        this.$store.dispatch('Components/setErrorPage', error.code)
      } finally {
        this.loading = false
      }
    },
    async getFulfillmentTags () {
      if (this.loadingFFM) {
        return
      }

      try {
        this.loadingFFM = true

        const { data } = await OrderfulfillmentSettingService.getMany({ isDefault: 0 })

        this.fulFillmentTags = data.map((st) => st.tag)
      } catch (error) {
        console.error('getFulfillmentTags', error)
        this.$store.dispatch('Components/setErrorPage', error.code)
      } finally {
        this.loadingFFM = false
      }
    },
    queryTags () {
      const result = ConvertQueryStringToArray(this.$route.query)

      this.query.search = result.search ? result.search : ''
      this.query.tags = result.tags ? result.tags : []
      this.query.tagOperation = result.tagOperation ? result.tagOperation : 'OR'
      this.query.brand = result.brand ? result.brand : 'all'
      this.query.collection = result.collection ? result.collection : ''
    },
    isIncludeTags (item, tags) {
      return item.tags.some((v) => tags.includes(v))
    },
    onConfirmShowOnWeb () {
      const toBeShow = this.itemSelected.filter((v) => !v.isOnWeb).length
      this.$store.dispatch('Components/setModal', {
        value: true,
        title: 'ยืนยันการแสดงสินค้าบนเว็บ',
        message: `มีสินค้า ${toBeShow} รายการ จาก ${this.itemSelected.length} รายการ จะถูกแสดงบนเว็บ`,
        confirmText: 'ยืนยัน',
        confirmType: 'success',
        cancelType: '',
        cancelText: 'ปิด',
        onConfirm: () => this.showOnWeb()
      })
    },
    onConfirmHideFromWeb () {
      const tobeHide = this.itemSelected.filter((v) => v.isOnWeb).length
      this.$store.dispatch('Components/setModal', {
        value: true,
        title: 'ยืนยันการซ่อนสินค้าจากเว็บ',
        message: `มีสินค้า ${tobeHide} รายการ จาก ${this.itemSelected.length} รายการ จะถูกซ่อนจากเว็บ`,
        confirmText: 'ยืนยัน',
        confirmType: 'success',
        cancelType: '',
        cancelText: 'ปิด',
        onConfirm: () => this.hideFromWeb()
      })
    },
    async showOnWeb () {
      try {
        this.$store.dispatch('Components/setLoading', {
          active: true,
          clickAble: false,
          message: 'PROCESSING...'
        })

        await AttributesAssignerService.showOnWeb({
          products: this.itemSelected.filter((v) => !v.isOnWeb).map((v) => v.id)
        })

        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: 'Show on web success.',
          type: 'success'
        })

        this.fetchProducts(true)
      } catch (error) {
        console.error('hideFromWeb', error)
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.$store.dispatch('Components/setLoading', { active: false })
      }
    },
    async hideFromWeb () {
      try {
        this.$store.dispatch('Components/setLoading', {
          active: true,
          clickAble: false,
          message: 'PROCESSING...'
        })

        await AttributesAssignerService.hideFromWeb({
          products: this.itemSelected.map((v) => v.id)
        })

        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: 'Hide from web success.',
          type: 'success'
        })

        this.fetchProducts(true)
      } catch (error) {
        console.error('hideFromWeb', error)
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.$store.dispatch('Components/setLoading', { active: false })
      }
    },
    addTags () {
      this.isAdd = true
      this.dialog = true
    },
    removeTags () {
      this.isAdd = false
      this.dialog = true
    },
    addGroupCategories () {
      this.isAdd = true
      this.groupCategoriesDialog = true
    },
    removeGroupCategories () {
      this.isAdd = false
      this.groupCategoriesDialog = true
    },
    onDragOver () {
      this.isDragging = true
    },
    onDragLeave () {
      this.isDragging = false
    },
    onDrop (event) {
      this.isDragging = false
      const file = event.dataTransfer.files[0]
      this.handleFile(file)
    },
    onFileChange (event) {
      const file = event.target.files[0]
      this.handleFile(file)
    },
    openFileDialog () {
      this.$refs.fileInput.click()
    },

    handleFile (file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        const text = e.target.result
        this.parseCSV(text)
      }
      reader.readAsText(file)
    },
    parseCSV (text) {
      const lines = text.trim().split('\n')
      const headers = lines[0].split(',').map((header) => header.trim().toLowerCase())
      const productIndex = headers.indexOf('product')

      if (headers.length === 0 || !headers.some((header) => header === 'product')) {
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: 'CSV must have some column with header "product".',
          type: 'error'
        })
        return
      }

      const PRODUCT_REGEX = /^\D+\.\d+\.\d+\.\d+\.\d+\.\d+(\.\d+)?$/

      const data = lines.slice(1).map((line) => {
        const values = line.split(',')
        const obj = {}

        const value = (values[productIndex]?.trim() || '')

        if (!PRODUCT_REGEX.test(value)) {
          obj.error = 'Invalid product model format.'
          return {
            ...obj,
            product: value
          }
        }

        const codes = value.split('.')
        let model = value
        if (codes.length === 7) {
          model = `${codes[0]}.${codes[1]}.${codes[2]}.${codes[3]}.${codes[4]}.${codes[5]}`
        }

        return {
          ...obj,
          product: model
        }
      })

      if (data.length === 0) {
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: 'CSV must have some data.',
          type: 'error'
        })
        return
      }
      const uniqueData = data.filter((item, index, self) => index === self.findIndex((t) => t.product === item.product))

      this.rawProductImport = uniqueData
      this.fetchProductImport()
    },
    async fetchProductImport () {
      try {
        this.loading = true

        let { data: foundProducts } = await ProductService.getManyProductByModel({ modelIds: this.rawProductImport.map((d) => d.product) })
        foundProducts = foundProducts.map((re) => ({
          id: re.id,
          model: re.model,
          name: re.name,
          isOnWeb: re.isOnWeb,
          photoUrls: re.photoUrls,
          tags: re.tags,
          groupCategories: re.groupCategories
        }))
        this.productImport = []
        this.rawProductImport.forEach((d) => {
          let payload = {}
          if (d.error) {
            payload = {
              id: d.product,
              name: d.product,
              model: d.product,
              tags: [],
              isOnWeb: false,
              photoUrls: [],
              errorMessage: d.error,
              error: true
            }
          } else {
            const productDB = foundProducts.find((p) => p.model === d.product)
            payload = productDB || {
              id: d.product,
              name: d.product,
              model: d.product,
              tags: [],
              isOnWeb: false,
              photoUrls: [],
              errorMessage: 'Product not found.',
              error: true
            }
          }

          if (this.productImport.findIndex((p) => p.model === payload.model) === -1) {
            this.productImport.push(payload)
          }
        })
      } catch (error) {
        console.error('fetchProducts', error)
        this.$store.dispatch('Components/setErrorPage', error.code)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.upload-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 260px);
  border: 1px dashed #ccc;
  border-radius: 6px;
}
.container-bg {
  background-color: white;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.text-error {
  color: #EF5350 !important;
}
.spin {
  animation: spin 1s linear infinite;
}
.drop-area {
  border: 1px dashed #ccc;
  padding: 2rem;
  /* text-align: center; */
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 260px);
  transition: background 0.3s ease;
}
.drop-area.drag-over {
  background-color: #f0f0f0;
  border-color: #999;
}
.template-wrapper {
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 6px;
}
.cat-loading {
  width: 200px;
  border-radius: 10%;
}

</style>
